<template lang="pug">
  map-main(embedded=true)
</template>





<script>
  import MapMain from '@/components/map/Main'

  export default {
    name: 'layout-embed',

    components: {
      MapMain
    }
  }
</script>





<style lang="sass">
  @import "../assets/sass/main"
  html, body
    height: 100%
</style>



// WEBPACK FOOTER //
// src/layouts/Embed.vue